export default __webpack_public_path__ + "static/media/Q.0dc93dee.svg";